<template>
  <div class="min-h-screen lg:flex">
    <Sidebar />
    <GlobalNavbar />
    <main class="min-w-0 flex-1 px-4 pb-8 pt-24 lg:ml-64 lg:px-8">
      <div v-if="categoryInfo">
        <Link href="/manuais" class="text-sm font-medium text-zinc-500 hover:text-zinc-950">← Todos os manuais</Link>
        <p class="mt-10 text-sm font-semibold text-blue-600">Categoria de manuais</p>
        <h1 class="mt-3 text-3xl font-bold tracking-tight text-zinc-950 sm:text-4xl">{{ categoryInfo.name }}</h1>
        <p class="mt-4 max-w-2xl text-lg leading-8 text-zinc-600">{{ categoryInfo.description }}</p>
        <div class="mt-10 grid gap-4 md:grid-cols-2 xl:grid-cols-3">
          <Link v-for="item in manuals" :key="item.manual.slug" :href="`/manuais/${item.manual.slug}`" class="rounded-xl border border-zinc-200 bg-white p-5 transition hover:border-zinc-400 hover:shadow-md">
            <p class="text-xs font-semibold uppercase tracking-wide text-zinc-400">{{ item.solution.name }}</p>
            <h2 class="mt-3 text-lg font-semibold leading-6 text-zinc-950">{{ item.manual.title }}</h2>
            <p class="mt-2 text-sm leading-6 text-zinc-600">{{ item.manual.description }}</p>
            <span class="mt-5 inline-block text-sm font-medium text-zinc-700">Ler manual →</span>
          </Link>
        </div>
      </div>
      <div v-else class="py-16">
        <h1 class="text-2xl font-semibold text-zinc-950">Categoria não encontrada</h1>
        <Link href="/manuais" class="mt-4 inline-block text-sm text-blue-600">Voltar aos manuais</Link>
      </div>
    </main>
  </div>
</template>

<script setup lang="ts">
import { Link } from "@inertiajs/vue3";
import Sidebar from "../components/layout/Sidebar.vue";
import GlobalNavbar from "../components/layout/GlobalNavbar.vue";
import { getCategoryInfo, getManualCategory, manualCatalog } from "../data/manualCatalog";

const props = defineProps<{ category: string }>();
const categoryInfo = getCategoryInfo(props.category);
const manuals = manualCatalog.flatMap((solution) => solution.manuals
  .filter((manual) => getManualCategory(manual) === props.category)
  .map((manual) => ({ manual, solution })));
</script>
